<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Identifier la ligne</div>
</div>
<span class="bold-label-text float-left">Quel nom voulez-vous donner à cette ligne ? *:</span>
<input type="text" class="form-control" maxlength="25" placeholder="Nom" [(ngModel)]="newName" required>
@if (error) {
    <small class="form-text error-message">Ce champ est obligatoire</small>
}

<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100 cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
    </div>
</div>
